import { SalesPackage } from "@/interfaces/packages/sales_packages";
export const ALL = "All";

export const filterPackages = (
  packages: SalesPackage[],
  params: { type: string; city: string }
): SalesPackage[] => {
  const { type, city } = params;
  let filteredPackages = packages;
  if (type !== ALL) {
    filteredPackages = filteredPackages.filter(p => p.type === type);
  }
  if (city !== ALL) {
    filteredPackages = filteredPackages.filter(p => p.city === city);
  }
  return filteredPackages;
};
